import classnames from 'classnames';
import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';
import PropTypes from 'prop-types';

import ActionMixin from 'components/lib/action_mixin';
import AgentGroups from './agent_groups';
import AppFeaturesMixin from '../lib/app_features_mixin';
import Inbox from 'models/location/inbox';
import Link from 'components/common/link';
import NavigateTo from 'actions/current_location/navigate_to';
import { getLocationUrl } from 'scripts/adapters/routes/location_url';
import { INBOX_COUNT_MAX } from 'models/inbox_count';

const AgentHome = createReactClass({
  propTypes: {
    binding: PropTypes.any,
    className: PropTypes.string,
    inboxState: PropTypes.shape({
      isTeam: PropTypes.bool,
      conversationStatus: PropTypes.string,
      routingGroupId: PropTypes.string,
      sortOrder: PropTypes.string,
    }).isRequired,
    personalInboxCount: PropTypes.number,
  },

  mixins: [ActionMixin, AppFeaturesMixin, Morearty.Mixin],

  render() {
    let classes = classnames('inboxMenu', this.props.className);
    let personalInboxClasses = classnames('inboxMenu-personalInboxLink', { active: !this.props.inboxState.isTeam });
    let count = this.props.personalInboxCount > INBOX_COUNT_MAX ? '999+' : this.props.personalInboxCount;
    return (
      <div className={classes}>
        <div className={personalInboxClasses}>
          <Link
            className="inboxMenu-personalInboxLink-text"
            href={getLocationUrl(AgentHome.personalInbox)}
            onClick={this.navigateToPersonalInbox}
          >
            <span className="inboxMenu-personalInboxLink-name">My Inbox</span>
            <span className="inboxMenu-personalInboxLink-count">{count}</span>
          </Link>
        </div>
        {this.renderGroupFilters()}
      </div>
    );
  },

  navigateToPersonalInbox() {
    this.executeAction(NavigateTo, AgentHome.personalInbox);
  },

  renderGroupFilters() {
    if (this.shouldShowGroupInboxes()) {
      return <AgentGroups teamInboxCounts={this.props.teamInboxCounts} />;
    }

    return null;
  },

  shouldShowGroupInboxes() {
    return this.isFeatureEnabled('groupInboxes');
  },

  statics: {
    personalInbox: Inbox.create(),
  },
});

export default AgentHome;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/agent_inbox/inbox_menu.jsx